import {z} from 'zod';

export const warrantySettingsFormSchema = z.object({
  defaultDuration: z.number().int().min(1).nullable(),
  warrantyProgramDurationOverrideDisabled: z.boolean(),
});

export type WarrantySettingsFormValues = z.infer<typeof warrantySettingsFormSchema>;
